<template>
    <div class="card z-index-2">

        <!-- <gradient-line-chart 
            id="chart-line" 
            title="Asistentes" 
            :chart="chart"
        /> -->

        <div class="card h-100">
            <div class="pb-0 card-header">
                <h6 class="">Estadísticas por día</h6>
                <!-- <p class="text-sm"><i class="fa fa-arrow-up text-success" aria-hidden="true"></i>
                    <span class="font-weight-bold">24%</span> this month
                </p> -->
            </div>
            <div class="p-3 card-body">
                <div class="timeline timeline-one-side" data-timeline-axis-style="dotted">
                    <div v-for="metric in metrics" :key="metric.date" class="mb-3 timeline-block"><span class="timeline-step"><i
                                class="ni text-gradient ni-check-bold text-info"></i></span>
                        <div class="timeline-content">
                            <h6 class="mb-0 text-sm font-weight-bold text-dark">{{metric.date}}</h6>
                            <p class="mt-1 mb-0 text-xs text-secondary font-weight-bold">
                                {{metric.prom_minutes}} min promedio
                            </p>
                            <p class="mt-1 mb-0 text-xs text-secondary font-weight-bold">
                                {{metric.total_users}} usuarios
                            </p>
                            <!---->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    {{ chart }}
</template>
<script>
import { fetchWrapper } from '@/helpers';
//import GradientLineChart from "@/examples/Charts/GradientLineChart.vue";

export default {
    name: "asistencia",
    data() {
        return {
            iconBackground: "bg-gradient-primary",
            metrics : []
        };
    },
    components: {
        //GradientLineChart
    },
    created() {
        this.getData();
    },
    methods: {
        async getData() {

            let from = "2022-11-01"
            let to = "2022-11-05";
            const baseUrl = process.env.VUE_APP_BASE_URL;
            const url = `${baseUrl}/v1/enter_leaves_metrics/count_minutes_for_dates/1/${from}/${to}`;

            // enviar con axios esta solicitud, si es ok, lo envía a login
            fetchWrapper.get(url)
                .then(result => {
                    this.metrics = result;
                })
                .catch(error => console.log(error))
        }
    }
};
</script>